import React from 'react';
import './SocialMediaModal.css';
import CloseIcon from '@mui/icons-material/Close';

function SocialMediaModal({ onClose }) {
    return (
        <div className="social-modal-overlay" onClick={onClose}>
            <div className="social-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="social-modal-close-btn" onClick={onClose}>
                    <CloseIcon />
                </button>
                <div className="social-modal-body">
                    <div className="social-modal-icon">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#002654"/>
                        </svg>
                    </div>
                    <h2 className="social-modal-title">Social Media (Coming Soon)</h2>
                    <p className="social-modal-text">
                        We're currently setting up our official social media pages.
                    </p>
                    <p className="social-modal-text">
                        Soon, you'll be able to connect with <strong>Astra Clean</strong> for updates, tips, and special offers.
                    </p>
                    <p className="social-modal-text">
                        Thank you for your patience and support!
                    </p>
                    <button className="social-modal-btn" onClick={onClose}>
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SocialMediaModal;
